export default {
  storeContactPageFormUrl(state, formUrl) {
    state.contactPageFormUrl = formUrl
  },
  storeUnitContactFormData(state, { buttonText, formUrl }) {
    state.unitContactFormData.buttonText = buttonText
    state.unitContactFormData.formUrl = formUrl
  },
}
